import { AppBar, TitlePortal } from 'react-admin';
import { Box } from '@mui/material';
// @ts-ignore
import logoImage from './images/nn-logo.png';
import { ChatBot } from "../chat-bot/ChatBot";
import { CacheFlushMenu } from "./CacheFlushMenu";
import { NotificationBell } from "./NotificationBell";


export const NokNokAppBar = () => (
    <AppBar>
        <TitlePortal />
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
        }}>
            <img style={ { width: '40px' } } src={logoImage} alt="NokNok Logo" />
             <span style={ { marginLeft: '20px' } } >{ "NokNok HQ" }</span>
        </Box>
        <Box component="span" sx={{ flex: 1 }} />
        <NotificationBell />
        <CacheFlushMenu />
        <ChatBot />
    </AppBar>
);